import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: ginlime
 * id D6011A13-DCCB-4DF7-B5A8-335A404C6B71
 * name arrow-left-right
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-right.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftRightIcon = createSvgIcon(<><path d="M6.45,17.45L1,12L6.45,6.55L7.86,7.96L4.83,11H19.17L16.14,7.96L17.55,6.55L23,12L17.55,17.45L16.14,16.04L19.17,13H4.83L7.86,16.04L6.45,17.45Z" /></>, 'ArrowLeftRightIcon');
export default ArrowLeftRightIcon